<template>
  <div class="text-field">
    <label v-if="label">{{ label }}</label>
    <input v-model="model" type="text" />
  </div>
</template>

<script setup>
import { computed } from "vue";

const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: {
    type: String,
  },
  id: {
    type: String,
  },
  name: {
    type: String,
  },
  label: {
    type: String,
  },
});

const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});
</script>

<style scoped lang="scss">
label {
  font-size: var(--sp-comp-dtv-text-field-label-font-size, 1rem);
  font-weight: var(--sp-comp-dtv-text-field-label-font-weight, 500);
  line-height: var(--sp-comp-dtv-text-field-label-line-height, 1.2);
}
input {
  display: flex;
  flex: 1;
  min-width: var(--sp-comp-dtv-text-field-input-min-width, 10ch);
  min-height: var(--sp-comp-dtv-text-field-input-min-height, 3rem);
  width: var(--sp-comp-dtv-text-field-input-width, 100%);
  border: {
    color: var(--sp-comp-dtv-text-field-input-border-color, var(--sp-sys-form-field-border-color));
    width: var(--sp-comp-dtv-text-field-input-border-width, var(--sp-sys-border-width-default));
    style: var(--sp-comp-dtv-text-field-input-border-style, var(--sp-sys-form-field-border-style));
  }
  border-radius: var(--sp-comp-dtv-text-field-input-border-radius, 0);
  font-size: var(--sp-comp-dtv-text-field-input-font-size, 1rem);
  padding-inline: var(--sp-comp-dtv-text-field-input-padding-inline, 1rem);
  padding-block: var(--sp-comp-dtv-text-field-input-padding-block, 0);
}
</style>
